'use client'

import { Divider } from '@/components/ui/divider'
import { TCollectionData } from '@/types/collection'
import { useTranslations } from 'next-intl'
import { FilterList } from '../filter-list/filter-list'

type Props = {
  serverData: TCollectionData
  initialFilters?: Record<string, string | string[] | number | undefined>
  title?: string
}

export const FilterGroupDesktop = ({
  serverData,
  initialFilters,
  title,
}: Props) => {
  const t = useTranslations('title')

  // Get facets from serverData
  const facets = serverData?.collection_detail?.facets || []
  const card_facets = serverData?.collection_detail?.card_facets || []

  return (
    <div className='sticky top-28 overflow-y-auto lg:max-h-[calc(100vh-100px)] lg:w-[294px] lg:pr-5'>
      <div className='flex items-center justify-between'>
        <p className='font-sans text-base font-medium leading-4.5 text-neutral-900'>
          {title ?? t('filter')}
        </p>
      </div>
      <Divider className='my-3 mb-0' />
      <FilterList
        facets={facets}
        card_facets={card_facets}
        initialFilters={initialFilters}
      />
    </div>
  )
}
